import React, { useEffect, useRef } from "react";
import { IAvatarSettings } from "../../utils/types";
import styles from "./Viewer.module.scss";

const IFRAME_TARGET_ORIGIN: string = process.env["NX_PUBLIC_IFRAME_ADDRESS"] || "";

console.log(`IFRAME_TARGET_ORIGIN: ${IFRAME_TARGET_ORIGIN}`);

export const Viewer = ({ settings }: { settings: IAvatarSettings }) => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const settingsRef = useRef(settings);
  
    useEffect(() => {
      settingsRef.current = settings;
    }, [settings]);

    useEffect(() => {
        setTimeout(() => {
            handleIframeLoad();
        }, 5000)
    }, []);
  
    const handleIframeLoad = () => {
        if (iframeRef.current && iframeRef.current.contentWindow) {
            iframeRef.current.contentWindow.postMessage(
                settings,
                IFRAME_TARGET_ORIGIN
            );
        }
    };
  
    return (
      <iframe
        ref={iframeRef}
        src={IFRAME_TARGET_ORIGIN}
        className={styles.iframe}
        width="100%"
        height="100%"
        title="Avatar player"
        allow="microphone"
        onLoad={handleIframeLoad}
        sandbox="allow-scripts allow-same-origin allow-modals allow-forms allow-popups allow-presentation"
      />
    );
  };